import statusService from "api/statusService";
import tagsService from "api/tagsService";
import CaseList from "components/CaseList";
import CaseView from "components/CaseView";
import PanelsLayout from "components/PanelsLayout";
import { ICaseSimple } from "dto/Cases/ICaseSimple";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./styles.module.scss";

import { IThread } from "dto/IThread";

const Cases = ({ hideMenu = false }: { hideMenu?: boolean }) => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [, setSelectedEdit] = useState<ICaseSimple | null>(null);
  const { caseId } = useParams();

  const { data: tagsData } = tagsService.useGetTags();
  const tags = useMemo(() => tagsData?.data ?? [], [tagsData]);
  const { data: statusesData } = statusService.useGetStatuses();
  const statuses = useMemo(() => statusesData?.data ?? [], [statusesData]);

  const [createNewThread, setCreateNewThread] = useState(false);

  const [selectedThread, setSelectedThread] = useState<IThread | null>(null);

  const [statusId, setStatusId] = useState<string | null>(null);
  const [tagId, setTagId] = useState<string | null>(null);
  const [entityId, setEntityId] = useState<string | null>(null);

  const handleChangeSearchBar = (
    text: string,
    statusId: string | null,
    tagId: string | null,
    entityId: string | null,
  ) => {
    setSearchText(text);
    setStatusId(statusId);
    setTagId(tagId);
    setEntityId(entityId);
  };

  useEffect(() => {
    const elements = JSON.parse(
      sessionStorage.getItem("copy_elements") ?? "[]",
    ).length;

    if (elements) {
      navigate(`/cases/${caseId!}/dossier`);
    }
  }, [caseId]);

  const leftPanel = () => {
    return (
      <>
        <CaseList
          createNewThread={createNewThread}
          setCreateNewThread={setCreateNewThread}
          selectedThread={selectedThread}
          setSelectedThread={setSelectedThread}
          tags={tags}
          statuses={statuses}
          setSelectedEdit={setSelectedEdit}
          searchText={searchText}
          statusId={statusId}
          tagId={tagId}
          entityId={entityId}
        ></CaseList>
      </>
    );
  };

  const rightPanel = () => {
    return (
      <CaseView
        forceMenu
        createNewThread={createNewThread}
        setCreateNewThread={setCreateNewThread}
        selectedThread={selectedThread}
        setSelectedThread={setSelectedThread}
        setSelectedEdit={setSelectedEdit}
        tags={tags}
        statuses={statuses}
        hideMenu={hideMenu}
        showCase
      ></CaseView>
    );
  };

  return (
    <>
      <PanelsLayout
        layoutName="cases"
        onChangeSearch={handleChangeSearchBar}
        disableHeader={hideMenu}
        defaultLeft={35}
        minLeft={30}
        leftPanel={leftPanel()}
        rightPanel={rightPanel()}
        resize
        leftClassName={styles.leftFull}
        allowRightPanelOverflow={true}
        trackActivePanel={true}
        isRightActive={!!caseId}
      />
    </>
  );
};
export default Cases;
